
const Footer = () => {
  return (
    <footer className="footer">All rights reserved © 2023</footer>
  )
}

export default Footer